module.exports = __webpack_public_path__ + "img/erp06.270c4db8.jpg";